import React from "react";
import styled from "styled-components";
import { Trans } from "react-i18next";
export class ReactSimpleRadioButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
      isOptionsVisible: false
    };
  }
  onOptionClick = item => {
    this.props.onChange(item);
  };

  indexOf = (options, value) => {
    let optionIndex = -1;
    for (let i = 0; i < options.length; i++) {
      if (value === options[i]) {
        optionIndex = i;
        break;
      }
    }
    return optionIndex;
  };

  render() {
    let self = this;
    let props = self.props;
    let className = props.className + " custom_radio_component";
    let isLinear = props.isLinear;
    let options =
      props.options && Array.isArray(props.options) ? props.options : [];
   
    let defaultSelected =
      props.defaultSelected &&
      self.indexOf(props.options, props.defaultSelected) > -1
        ? props.defaultSelected
        : null;

    return (
      <ParentDiv>
        <div className={className}>
          <div className="container">
            <ul
              className={"radio_group_container " + (isLinear ? "linear" : "")}
            >
              {options.map((item, index) => {
                return (
                  <li
                    key={index}
                    className={"radio_item " + (isLinear ? "linear" : "")}
                    onClick={() => this.onOptionClick(item)}
                  >
                    <input
                      type="radio"
                      defaultChecked={item === defaultSelected ? true : false}
                      id={"option_label" + index}
                      name="selector"
                    />
                    <label
                      htmlFor={"option_label" + index}
                      className="radio_label"
                    >
                      <Trans>{item}</Trans>
                    </label>
                    <div className="check" />
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </ParentDiv>
    );
  }
}
const ParentDiv = styled.div`
  .custom_radio_component {
    .container {
      width: 100%;
      padding-right: 0px !important;
      padding-left: 0px !important;
      margin-right: auto;
      margin-left: auto;
    }
    .radio_group_container {
      display: flex;
      list-style: none;
      margin: 0;
      padding: 0;
      .radio_item {
        display: flex;
        padding: 10px 13px 10px 5px;
        position: relative;
        align-items: center;
        input[type="radio"] {
          position: absolute;
          visibility: hidden;
          left: 1px;
        }
        .radio_label {
          padding-left: 8px;
          z-index: 9;
          cursor: pointer;
          -webkit-transition: all 0.25s linear;
          -webkit-transition: all 0.25s linear;
          transition: all 0.25s linear;
          padding-top: 10px;
          display: block;
          position: relative;
          width: 88px;
          text-align: center;
          padding-left: 15px;
          //right: 10px;
        }
        .check {
          display: block;
          position: absolute;
          left: 0;
          border: 1px solid #b2b7be;
          border-radius: 100%;
          height: 16px;
          width: 16px;
          z-index: 5;
          transition: border 0.25s linear;
          -webkit-transition: border 0.25s linear;
          &::before {
            display: block;
            position: absolute;
            content: "";
            border-radius: 100%;
            height: 10px;
            width: 10px;
            top: 2px;
            left: 2px;
            margin: auto;
            transition: background 0.25s linear;
            -webkit-transition: background 0.25s linear;
          }
        }
        &:hover .check {
          border: 1px solid #b2b7be;
        }
      }
      input[type="radio"]:checked ~ .check {
        border-color: #c4151c;
      }
      input[type="radio"]:checked ~ .check::before {
        background: #c4151c;
      }
      &.linear {
        display: flex;
        .radio_item:not(:first-child) {
          margin-left: 30px;
        }
      }
    }
  }
`;
